export const trackLinkedinEvent = (name) => {
	const config = useRuntimeConfig()
	if (config.public.LINKEDIN_CONVERSION_ENABLED) {
		const id = config.public[`LINKEDIN_CONVERSION_${name}_ID`]
		window.lintrk('track', { conversion_id: id })
	}
}
